<div class="common-table-style">
  <div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <ng-icon name="heroClipboardDocument"></ng-icon>
      <h2>All Contracts</h2>
    </div>
    <div class="d-flex justify-content-between align-items-center col-md-6 p-0">
      <div class="filter-container">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Search Contract</mat-label>
          <input matInput (keyup)="applyFilter($event.target.value)" autocomplete="off">
          <mat-icon matSuffix><ng-icon name="heroMagnifyingGlass"></ng-icon></mat-icon>
        </mat-form-field>
          <mat-form-field appearance="outline" class="status-filter">
            <mat-label>Filter by Status</mat-label>
            <mat-select [(value)]="currentStatusFilter" (selectionChange)="filterByStatus($event.value)">
              <mat-option value="all" selected>All</mat-option>
              <mat-option value="Initiated">Initiated</mat-option>
              <mat-option value="Pending Signature">Pending Signature</mat-option>
              <mat-option value="Signed">Signed</mat-option>
              <mat-option value="Approved">Approved</mat-option>
              <mat-option value="Expired">Expired</mat-option>
              <mat-option value="Terminated">Terminated</mat-option>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Reviewed">Reviewed</mat-option>
              <mat-option value="Pending Approval">Pending Approval</mat-option>
              <mat-option value="Rejected">Rejected</mat-option>
            </mat-select>
          </mat-form-field>
      </div>
      <button color="accent" mat-raised-button [routerLink]="['/app/contract/add']">
        Initiate Contract </button>
    </div>
  </div>
  <div class="inner-box">
    

    <mat-table [dataSource]="dataSource" matSort (matSortChange)="customSortData($event)">
      <ng-container matColumnDef="Contract Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contract Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button color="accent" disableRipple [routerLink]="['/app/contract', 'view', element.id]"
            matTooltip="View Contract {{element.contractName | titlecase}}" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100">
            {{ element.contractName | titlecase }}
          </a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Contract Type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contract Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.contractType | titlecase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Created By">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.createdBy }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Created Date">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.createdDate }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Last Updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.updateDate }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="status-pill" [ngClass]="
          element.status == 'Signed' || element.status == 'Approved' ? 'success' :
          element.status == 'Rejected' || element.status == 'Pending Approval' ? 'error' :
          element.status == 'Expired' ? 'expired' :
          'warning'">{{ element.status }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
        <mat-cell *matCellDef="let element" class="action">
          <a mat-button color="accent" disableRipple [routerLink]="['/app/contract','edit',element.id]"
            matTooltip="Edit Contract {{element.contractName | titlecase}}" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100">
            <ng-icon name="heroPencil"></ng-icon>
          </a>
          <a mat-button color="accent" disableRipple (click)="downloadDoc(element)" *ngIf="element.isMandatoryFilled"
            matTooltip="Download Contract" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
            <mat-progress-spinner *ngIf="isLoading[element.id]; else go" mode="indeterminate" color="accent"
              diameter="24"></mat-progress-spinner>
            <ng-template #go>
              <span
                *ngIf="element.status != 'Approved' && element.status != 'Signed' && element.status != 'Pending Signature'"><ng-icon
                  name="faFileWord"></ng-icon></span>
              <span class="pdf"
                *ngIf="element.status == 'Approved' || element.status == 'Signed' || element.status == 'Pending Signature'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                </svg>
              </span>
            </ng-template>
          </a>
          <a mat-button color="accent" disableRipple *ngIf="element.status == 'Approved' && 
userService.permissionsValue['_CONTRACT_'+element.contractType.toUpperCase()+'_EDIT_']"
            (click)="openDeleteConfirmation(element.id)" matTooltip="Signature" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100" style="background: transparent; border: transparent; padding: 0px;"><ng-icon
              name="heroDocumentArrowUp"></ng-icon></a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>

    <ng-container *ngIf="dataSource.filter &&  dataSource.filteredData.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no contracts found with <strong>'{{dataSource.filter}}'</strong></p>
      </div>
    </ng-container>

    <ng-container *ngIf="dataSource.data.length === 0">
      <div class="skeleton-box">
        <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
      </div>
    </ng-container>

    <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>